(function (angular) {
    'use strict';

    angular
        .module('app.privacy-policy', []);
        
})(angular);
